import { reaction } from "mobx"
import { useEffect, useState } from "react"

import { userSessionStore } from "~/domain/user-session/model/store"

/**
 * Возвращает информацию о пользователе, хранящаяся в состоянии, если она есть
 * @hook
 * @category Hook
 */
export function useUserInfo() {
	const [userInfo, setUserInfo] = useState(userSessionStore.userInfo)

	useEffect(() => {
		return reaction(
			() => userSessionStore.userInfo,
			(newUserInfo) => setUserInfo(newUserInfo),
		)
	}, [])

	return userInfo
}
